<template>
  <v-dialog v-model="dialog" max-width="600px" persistent scrollable>
    <v-form v-model="valid" ref="form">
      <v-card>
        <v-card-title class="blue darken-4 white--text">
          <v-toolbar-title>THÔNG TIN HỖ TRỢ</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-6 pb-2">
          <v-row no-gutters>
            <v-col cols="12">
              <v-select
                v-model="subStatus"
                label="Trạng thái chi tiết"
                placeholder="Trạng thái chi tiết"
                :items="subStatusOptions"
                :rules="[$rules.required]"
                item-value="name"
                item-text="name"
                outlined
                validate-on-blur
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-6">
          <v-btn color="blue darken-4" text @click="cancel" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-4" dark @click="confirm">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
  },
  components: {},
  data() {
    return {
      note: '',
      inCharge: null,
      valid: false,
      subStatus: '',
      subStatusOptions: [{ name: 'Có thay đổi' }, { name: 'Không thay đổi' }],
    }
  },
  computed: {},
  methods: {
    confirm() {
      if (this.$refs.form.validate()) {
        const data = {
          subStatus: this.subStatus,
          logNote: this.note,
        }
        this.$emit('inputConfirmed', { ...data })
      }
    },
    setIncharge(data) {
      this.inCharge = data
    },
    cancel() {
      this.$emit('closeDialog')
    },
  },
}
</script>
